import { Grid, useMediaQuery, useTheme } from "@mui/material"
import { AddEtapaForm } from "components/AddEtapaForm";
import { EtapaList } from "components/EtapaList";
import { EtapaPadraoTable } from "components/EtapaPadraoTable";
import { useEffect, useState } from "react";
import { EtapaPadrao, useGetEtapasPadroesQuery } from "shared/features/api/etapaPadrao/etapaPadraoSlice";

export const ConfigEtapa: React.FC = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const {data: etapasPadrao} = useGetEtapasPadroesQuery();
    const [etapas, setEtapas] = useState<EtapaPadrao[]>([]);

    useEffect(()=>{
        if(etapasPadrao) {
            setEtapas([...etapasPadrao].sort((a, b) => a.ordem - b.ordem))
        }
    }, [etapasPadrao])

    return (
        <Grid 
            container
            display={"flex"}
            direction={isSmallScreen ? "column" : "row"}
            sx={{
                gap: 1,
                p: 3
            }}
        >
            <AddEtapaForm/>
            <EtapaList/>
            {etapasPadrao && (
                <EtapaPadraoTable etapas={etapas}/>
            )}
        </Grid>
    )
}